// extracted by mini-css-extract-plugin
export default {"button":"Button_button__MZCgK","isActive":"Button_isActive__KPwhy","icon":"Button_icon__vbV2C","text":"Button_text__KXr8W"};